import './styles/global.css';

import { createApp } from 'vue'
import { createHead } from '@unhead/vue/client';

import i18n from './i18n';
import store from './stores';
import globalComponents from './components';
import directive from './directive';
import router from './router';
import App from './app.vue';
import lozad from './utils/lozad';

import './styles/base.scss';

const observer = lozad('.lozad', {
  enableAutoReload: true,
});

observer.observe();

const app = createApp(App);
const head = createHead();

app.use(head);
app.use(i18n);
app.use(store);
app.use(globalComponents);
app.use(directive);
app.use(router);

app.mount('#app');
